/**
 * Duck
 * @author Otávio Bastilho
 * @copyright 08/2019
 */

import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
	getFreeGatesAsync: ['idLoad'],
	getFreeGatesLoading: [],
	getFreeGatesError: [],
	cleanGates: []
});

/**
 * Handlers
 */
const INITIAL_STATE = {
	freeGates: {},
	loading: false,
	error: undefined,
};

const getFreeGates = (state = INITIAL_STATE, action) => {
	return { ...INITIAL_STATE, freeGates: action.payload };
}

const getFreeGatesLoading = (state = INITIAL_STATE, action) => {
	return { ...INITIAL_STATE, loading: true };
}

const getFreeGatesError = (state = INITIAL_STATE, action) => {
	return { ...INITIAL_STATE, error: action.payload };
}

const cleanGates = (state = INITIAL_STATE, action) => {
	return INITIAL_STATE;
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
	[Types.GET_FREE_GATES_ASYNC]: getFreeGates,
	[Types.GET_FREE_GATES_LOADING]: getFreeGatesLoading,
	[Types.GET_FREE_GATES_ERROR]: getFreeGatesError,
	[Types.CLEAN_GATES]: cleanGates
});
